/**
 * Two-letter initials for avatar fallback when the Member has no profile photo.
 */
export function getUserDisplayInitials(
	user: { name?: string | null; userName?: string | null } | null | undefined
): string {
	if (!user) return '?'

	const name = user.name?.trim()
	const handle = user.userName?.trim()
	const primary = name || handle || ''
	if (!primary) return '?'

	const words = primary.split(/\s+/).filter(Boolean)
	if (words.length >= 2) {
		const first = words[0]?.[0]
		const last = words[words.length - 1]?.[0]
		if (first && last) return `${first}${last}`.toUpperCase()
	}

	const alnum = primary.replace(/[^a-zA-Z0-9]/g, '')
	if (alnum.length >= 2) return alnum.slice(0, 2).toUpperCase()
	if (alnum.length === 1) return `${alnum[0]}${alnum[0]}`.toUpperCase()

	return primary.slice(0, 2).toUpperCase()
}

const collapseComparable = (s: string) => s.replace(/\s+/g, '').toLowerCase()

/** Username / handle line only when it differs from the display name (avoids duplicate lines). */
export function distinctMemberHandle(name?: string | null, userName?: string | null): string | null {
	const u = userName?.trim()
	if (!u) return null
	const n = name?.trim()
	if (!n) return u
	if (collapseComparable(u) === collapseComparable(n)) return null
	return u
}
